// CreateVideoModule.js
// @author: anghello

import React, { useState, useCallback, useEffect, Fragment, useRef } from 'react';
import { CardBody, Card, NavItem, TabPane, Nav, TabContent, NavLink, CardHeader, Button, UncontrolledAlert, Modal, ModalHeader, ModalBody } from 'reactstrap';
import classnames from 'classnames';
import VideoSong from './components/VideoSong';
import VideoStyle from './components/VideoStyle';
import VideoPhotos from './components/VideoPhotos';
import VideoReview from './components/VideoReview';
import VideoDetails from './components/VideoDetails';
import Strings from '../../translations/Translations';
import RemixHelper from '../../helpers/RemixHelper';
import { useAuth } from '../../Context/Auth/AuthContext';
import PSO from '../../services/PSO';
import { toast } from 'react-toastify';
import { useHistory, useLocation } from 'react-router-dom';
import FileHelper from '../../helpers/FileHelper';
import Assets from '../../services/Assets';
import GenresMap from '../../enums/GenresMap';
import axios from 'axios';
import CanvasHelper from '../../helpers/CanvasHelper';
import TextPhotoDefaults from '../../enums/TextPhotoDefaults';
import PhotoResizer from '../../helpers/PhotoResizer';
import { getCreditsCostLabel } from '../../helpers/GetCreditsCostLabel';
import ProcessImageForUpload from '../../helpers/ProcessImageForUpload';

const REACT_APP_PZ_IMAGE_SRC = process.env.REACT_APP_PZ_IMAGE_SRC;
const mediaPackMapJsonSrc = process.env.PUBLIC_URL + '/mediapackmap.json';
const ENABLE_GENERATE_TEXT_PHOTO = true;
const REACT_APP_MAX_UPLOAD_PHOTO_WIDTH = parseInt(process.env.REACT_APP_MAX_UPLOAD_PHOTO_WIDTH);
const REACT_APP_MAX_UPLOAD_PHOTO_HEIGHT = parseInt(process.env.REACT_APP_MAX_UPLOAD_PHOTO_HEIGHT);

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const randomIntFromInterval = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export default function CreateVideoModule (props) {
  const { authenticated, toggleLoading, currentCampaign, checkCredits } = useAuth();
  const history = useHistory();

  const query = useQuery();

  const [showPreviousBtn, setShowPreviousBtn] = useState(false);
  const [showNextBtn, setShowNextBtn] = useState(true);
  const [showCreateBtn, setShowCreateBtn] = useState(false);
  const [showCancelBtn, setShowCancelBtn] = useState(true);

  const [showCreatedVideoAlert, setShowCreatedVideoAlert] = useState(false);

  const [modalCancel, setModalCancel] = useState(false);
  const toggleModalCancel = useCallback(() => {
    setModalCancel(value => !value);
  }, [setModalCancel]);

  const [activeTab, setActiveTab] = useState('1');
  const toggleTab = useCallback((tab) => {
    setActiveTab(tab);

    const newTab = parseInt(tab);
    setShowPreviousBtn(newTab !== 1);
    setShowNextBtn(newTab !== 5);
    setShowCreateBtn(newTab === 5);
    setShowCancelBtn(newTab === 1);
  }, [setActiveTab, setShowPreviousBtn, setShowNextBtn, setShowCreateBtn, setShowCancelBtn]);

  const scrollTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const [automaticCreated, setAutomaticCreated] = useState(false);

  const [hashtagStyle, setHashtagStyle] = useState('featured');

  // REMIX Pars
  const [style, setStyle] = useState();
  const [song, setSong] = useState();
  const [songType, setSongType] = useState();
  const [remixPars, setRemixPars] = useState({
    rstag: '',
    rti: '',
    rde: '',
    rfsnm: 20,
    rfsownernm: 30,
    rmcsa: 0,
    rautoapp: 0,
    rssm: 0,
    rsmir: 0,
    rdmdown: 1,
    blksnow: 0,
    lati: '',
    long: '',
    featVideoPopFans: 0
  });
  const [remixMedia, setRemixMedia] = useState();

  const [customLatiLong, setCustomLatiLong] = useState(false);

  const audioPreviewRef = useRef();
  const audioSelectedRef = useRef();

  const [creditAction] = useState('createRemix');
  const [labelCreditsCost, setLabelCreditsCost] = useState('');
  const hookGetCreditsCostLabel = useCallback(async () => {
    const { un, al } = authenticated;
    const creditsMultiplier = null;
    let creditsSecondaryAction = null;
    const label = await getCreditsCostLabel(un, al, creditAction, creditsMultiplier, creditsSecondaryAction);
    setLabelCreditsCost(label);
  }, [authenticated, creditAction]);
  useEffect(() => { hookGetCreditsCostLabel() }, [hookGetCreditsCostLabel]);

  const validateDetails = useCallback((currentTab) => {
    if (currentTab !== 4) {
      return true;
    } else {
      let valid = true;

      // Validating title
      if (remixPars.rti === undefined || typeof remixPars.rti === 'undefined' || typeof remixPars.rti === undefined || remixPars.rti === '' || remixPars.rti === ' ' || remixPars.rti === null) {
        valid = false;
        toast.error(Strings('you_must_select_insert_a_title'));
      }

      // Validating startag
      const startag_pattern = new RegExp ("^[A-Za-z0-9_]{3,140}$");
      if (remixPars.rstag === undefined || typeof remixPars.rstag === 'undefined' || typeof remixPars.rstag === undefined || remixPars.rstag === '' || remixPars.rstag === ' ' || remixPars.rstag === null) {
        valid = false;
        toast.error(Strings('you_must_select_insert_a_startag'));
      } else if (!startag_pattern.test(remixPars.rstag)) {
        valid = false;
        toast.error(Strings('startag_requirements'));
      }

      if (!valid) {
        scrollTop();
      }

      return valid;
    }
  }, [remixPars, scrollTop]);

  const processHashtagStyle = useCallback((hashTagToSet) => {
    if (hashTagToSet) {
      hashTagToSet = hashTagToSet.toLowerCase();
      hashTagToSet = hashTagToSet.trim();
      hashTagToSet = hashTagToSet.replaceAll(' ', '');
      setHashtagStyle(hashTagToSet);
    }
  }, [setHashtagStyle]);

  const validateVideoBeforeCreate = useCallback(() => {
    let valid = true;

    // Validating style
    if (style === undefined || typeof style === 'undefined' || typeof style === undefined || style === '' || style === ' ' || style === null) {
      valid = false;
      toast.error(Strings('you_must_select_a_style'));
    }

    // Validating song
    if (songType === undefined || typeof songType === 'undefined' || typeof songType === undefined || songType === '' || songType === ' ' || songType === null  || song === undefined || typeof song === 'undefined' || typeof song === undefined || song === '' || song === ' ' || song === null) {
      valid = false;
      toast.error(Strings('you_must_select_a_song'));
    }

    // Validating startag
    const startag_pattern = new RegExp ("^[A-Za-z0-9_]{3,140}$");
    if (remixPars.rstag === undefined || typeof remixPars.rstag === 'undefined' || typeof remixPars.rstag === undefined || remixPars.rstag === '' || remixPars.rstag === ' ' || remixPars.rstag === null) {
      valid = false;
      toast.error(Strings('you_must_select_insert_a_startag'));
    } else if (!startag_pattern.test(remixPars.rstag)) {
      valid = false;
      toast.error(Strings('startag_requirements'));
    }

    // Validating title
    if (remixPars.rti === undefined || typeof remixPars.rti === 'undefined' || typeof remixPars.rti === undefined || remixPars.rti === '' || remixPars.rti === ' ' || remixPars.rti === null) {
      valid = false;
      toast.error(Strings('you_must_select_insert_a_title'));
    }

    // Validating media
    if (remixMedia === null || remixMedia.length === 0) {
      valid = false;
      toast.error(Strings('you_must_select_a_media'));
    }

    // Validating first and last elements of remix media
    if (remixMedia) {
      if (remixMedia[0].type === 'video' || remixMedia[remixMedia.length - 1].type === 'video') {
        valid = false;
        toast.error(Strings('the_first_media_should_be_a_Photo'));
      }
    }

    return valid;
  }, [style, songType, song, remixPars, remixMedia]);

  const createVideo = useCallback(async () => {
    // Check CREDITS
    const creditsMultiplier = null;
    const creditsSecondaryAction = null;
    const userCanDoAction = await checkCredits(creditAction, creditsMultiplier, creditsSecondaryAction);
    if (!userCanDoAction) {
      return;
    }

    const validToCreate = validateVideoBeforeCreate();

    if (!validToCreate) {
      // Not able to create video
      return false;
    }

    // Inverting MEDIA array
    const localRemixMedia = [...remixMedia].reverse();

    // Getting default remix arguments
    const remixArguments = RemixHelper.getDefaultRemixArguments();
    let appleMusicParams = null;

    // Auth arguments
    remixArguments.al = authenticated.al;
    remixArguments.un = authenticated.un;

    // Style
    remixArguments.rstyle_sid = `${style.id}`;
    remixArguments.rsong_sid = `${style.ms}`;

    // Song
    if (songType === 1) {
      remixArguments.rsong_sid = `${song.obj.id}`;
    } else if (songType === 2) {
      // Defining Music Video
      remixArguments.mvon = 1;

      if (song && song.obj && song.obj.id) {
        const appleMusicId = song.obj.id;

        // Getting Apple Music parameters
        toggleLoading(true, Strings('getting_music_details'));

        try {
          const response = await PSO.appleMusicSearchID(appleMusicId);

          if (response.data && response.data.length > 0) {
            const targetMusic = response.data[0];

            appleMusicParams = {};
            appleMusicParams.mvon = 1; // Music Video ON
            appleMusicParams.apmon = 1; // Apple Music Video ON
            appleMusicParams.apmsoid = appleMusicId; // Apple Music Song ID
            appleMusicParams.apmna = encodeURIComponent(targetMusic.attributes.name); // Apple Music Name
            appleMusicParams.apmgen = encodeURIComponent(targetMusic.attributes.genreNames[0]); // Apple Music Genre
            appleMusicParams.apmart = encodeURIComponent(targetMusic.attributes.artistName); // Apple Music Artist
            appleMusicParams.apmpageurl = targetMusic.attributes.url;

            // Apple Music Album ID
            if (targetMusic && targetMusic.relationships && targetMusic.relationships.albums && targetMusic.relationships.albums.data && targetMusic.relationships.albums.data[0] && targetMusic.relationships.albums.data[0].id) {
              appleMusicParams.apmartid = targetMusic.relationships.albums.data[0].id;
            }

            // Apple Music Artist ID
            if (targetMusic && targetMusic.relationships && targetMusic.relationships.artists && targetMusic.relationships.artists.data && targetMusic.relationships.artists.data[0] && targetMusic.relationships.artists.data[0].id) {
              appleMusicParams.apmalbid = targetMusic.relationships.artists.data[0].id;
            }

            let artwork = targetMusic.attributes.artwork.url;
            artwork = artwork.replace('{w}', '800');
            artwork = artwork.replace('{h}', '800');
            let preview = targetMusic.attributes.previews[0].url;
  
            appleMusicParams.apmthmurl = artwork; // Apple Music Thumb URL
            appleMusicParams.apmpsourl = preview; // Apple Music Song URL
          }
        } catch (err) {
          console.error(err);
        }
        
        toggleLoading(false);
      }
    }

    // Remix pars
    remixArguments.rti = encodeURIComponent(remixPars.rti);
    remixArguments.rstag = remixPars.rstag;

    if (remixPars.rde === '') {
      remixArguments.rde = ' ';
    }
    
    // Hashtags
    remixArguments.rde = remixPars.rde;
    remixArguments.rde = `${remixArguments.rde} \n\n ||)  #${hashtagStyle}`;

    if (remixArguments.rde && remixArguments.rde !== '' && remixArguments.rde !== ' ' && remixArguments.rde !== null) {
      remixArguments.rde = encodeURIComponent(remixArguments.rde);
    }
    if (remixPars.rfsownernm && remixPars.rfsownernm !== '' && remixPars.rfsownernm !== ' ' && remixPars.rfsownernm !== null) {
      remixArguments.rfsnm = remixPars.rfsownernm;
    }
    if (remixPars.rmcsa !== '' && remixPars.rmcsa !== ' ' && remixPars.rmcsa !== null) {
      remixArguments.rmcsa = remixPars.rmcsa;
    }
    if (remixPars.rautoapp !== '' && remixPars.rautoapp !== ' ' && remixPars.rautoapp !== null) {
      remixArguments.rautoapp = remixPars.rautoapp;
    }
    if (remixPars.rssm !== '' && remixPars.rssm !== ' ' && remixPars.rssm !== null) {
      remixArguments.rssm = remixPars.rssm;
    }
    if (remixPars.rsmir !== '' && remixPars.rsmir !== ' ' && remixPars.rsmir !== null) {
      remixArguments.rsmir = remixPars.rsmir;
    }
    if (remixPars.blksnow !== '' && remixPars.blksnow !== ' ' && remixPars.blksnow !== null) {
      remixArguments.blksnow = remixPars.blksnow;
    }
    if (remixPars.rdmdown !== '' && remixPars.rdmdown !== ' ' && remixPars.rdmdown !== null) {
      remixArguments.rdmdown = remixPars.rdmdown;
    }
    if (customLatiLong) {
      if (customLatiLong.lati && customLatiLong.lati !== '' && customLatiLong.lati !== ' ' && customLatiLong.lati !== null) {
        remixArguments.lati = encodeURIComponent(customLatiLong.lati);
      }
      if (customLatiLong.long && customLatiLong.long !== '' && customLatiLong.long !== ' ' && customLatiLong.long !== null) {
        remixArguments.long = encodeURIComponent(customLatiLong.long);
      }
    } else {
      if (remixPars.lati && remixPars.lati !== '' && remixPars.lati !== ' ' && remixPars.lati !== null) {
        remixArguments.lati = encodeURIComponent(remixPars.lati);
      }
      if (remixPars.long && remixPars.long !== '' && remixPars.long !== ' ' && remixPars.long !== null) {
        remixArguments.long = encodeURIComponent(remixPars.long);
      }
    }

    // Featuring Video in PopFans
    if (remixPars.featVideoPopFans === 1) {
      remixArguments.mvon = 1;
      remixArguments.app = 'pbmv';
    }

    let etxtjsonCreate;
    let renderedFileBLOBCreate;
    let originalFileBLOBCreate;
    
    // Remix media
    if (localRemixMedia[0].type === 'mediapack') {
      const images = localRemixMedia;

      remixArguments.eti = 'remixPhoto.jpg';
      remixArguments.uptype = 1;
      remixArguments.upfn = images[0].eid;
    } else if (localRemixMedia[0].type === 'file') {
      const targetFile = localRemixMedia[0].file;
      const fileDataURI = localRemixMedia[0].src;
      const fileBLOB = FileHelper.dataURItoBlob(fileDataURI);

      remixArguments['Filedata'] = fileBLOB;
      remixArguments['Filename'] = targetFile.name;
    } else if (localRemixMedia[0].type === 'textphoto') {
      if (localRemixMedia[0].layers && localRemixMedia[0].layers.length > 0 && localRemixMedia[0].layers[0] !== null) {
        // const originalFileBLOB = FileHelper.dataURItoBlob(localRemixMedia[0].layers[0].dataUri);
        const originalFileBLOB = await RemixHelper.generateBasePhotoWithLayer(localRemixMedia[0].layers);
        originalFileBLOBCreate = FileHelper.dataURItoBlob(originalFileBLOB);
        renderedFileBLOBCreate = FileHelper.dataURItoBlob(localRemixMedia[0].src);

        const txts = [];
        if (localRemixMedia[0].layers && localRemixMedia[0].layers.length > 0) {
          localRemixMedia[0].layers.forEach((item) => {
            if (item.type === 'text') {
              let x = item.x;
              let y = item.y;
              const h = item.h;
              const w = item.w;

              if (item.textAlign === 'center') {
                if (item.renderedW) {
                  x = x - (item.renderedW / 2);
                }
                if (item.renderedH) {
                  y = y - (item.renderedH / 2);
                }
              }

              x = x - TextPhotoDefaults.COMPATIBILITY_X_FACTOR;
              y = y - TextPhotoDefaults.COMPATIBILITY_Y_FACTOR;

              txts.push({
                t: RemixHelper.generateTextLayerBreakLine(item),
                c: encodeURIComponent(item.color),
                y: y,
                x: x,
                h: h,
                w: w,
                a: 0,
                s: item.fontSize / TextPhotoDefaults.SCALE_FACTOR,
                f: encodeURIComponent(item.font),
                app: 'web'
              });
            }
          });
        }

        etxtjsonCreate = {
          isTxtPhoto: true,
          txts: txts
        };

        remixArguments['etxtjson'] = JSON.stringify(etxtjsonCreate);
        remixArguments['Filedata'] = originalFileBLOBCreate;
        remixArguments['Filename'] = 'remixPhoto.jpg';
      }
    } else if (localRemixMedia[0].type === 'unsplash') {
      const targetFile = localRemixMedia[0];
      const fileDataURI = targetFile.src;
      const fileBLOB = FileHelper.dataURItoBlob(fileDataURI);

      remixArguments['Filedata'] = fileBLOB;
      remixArguments['Filename'] = targetFile.name;
    }

    let remixCreated = false;
    let remixCreatedId = null;
    let remixCreatedTid = null;

    let startagExists = false;
    let errorOnStartag = false;

    // Checking if startag exists
    toggleLoading(true, Strings('checking_video_details'));
    try {
      const response = await PSO.checkStarTagExists({
        un: authenticated.un,
        al: authenticated.al,
        rstag: remixPars.rstag
      });
      if (response && response.result) {
        if (response.result === 'success') {
          if (response.systemstartagexists && (response.systemstartagexists === 1 || response.systemstartagexists === '1')) {
            startagExists = true;
          }
          if (response.userstartagexists && (response.userstartagexists === 1 || response.userstartagexists === '1')) {
            startagExists = true;
          }
        } else {
          errorOnStartag = true;
        }
      }
    } catch (err) {
      errorOnStartag = true;
      console.error(err);
    }
    toggleLoading(false);

    if (errorOnStartag) {
      return false;
    }
    if (startagExists) {
      toast.error(Strings('startag_already_exists'));
      return false;
    }

    // Creating remix
    toggleLoading(true, Strings('creating_video'));
    try {
      const response = await PSO.createRemixWithPhoto(remixArguments);
      if (response.result === 'success' && response.remix_id) {
        remixCreated = true;
        remixCreatedId = response.remix_id;
        remixCreatedTid = response.tid;

        if (localRemixMedia[0].type === 'textphoto') {
          if (response.element_id) {
            const elementId = response.element_id;
  
            const replacePhotoArgs = {
              al: authenticated.al,
              un: authenticated.un,
              rid: remixCreatedId,
              eid: elementId,
              etxtjson: JSON.stringify(etxtjsonCreate),
              Filedata: renderedFileBLOBCreate,
              Filename: 'remixPhoto.jpg', 
            }
            await PSO.replacePhotoInRemix(replacePhotoArgs);

            // Changing foto animation to crop to FIT
            const cropToFixArgs = {
              al: authenticated.al,
              un: authenticated.un,
              etype: 1,
              eid: elementId,
              eaid: '1003'
            }
            await PSO.modifyElementGlobal(cropToFixArgs);
          }
        }
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }
    } catch (err) {
      console.error(err);
      toast.error(Strings('error_on_create_remix'));
    }
    toggleLoading(false);

    let firstElementEid;

    if (remixCreated) {
      // Sending more media

      if (localRemixMedia.length > 1) {
        for (let i = 1; i < localRemixMedia.length; i++) {
          toggleLoading(true, `${Strings('sending_media')} - ${i+1} ${Strings('of')} ${localRemixMedia.length}`);

          const currentImage = localRemixMedia[i];

          if (currentImage && currentImage.type === 'mediapack') {
            try {
              const sendPhotoArgs = {
                al: authenticated.al,
                un: authenticated.un,
                rid: remixCreatedId,
                uptype: 1,
                upfn: currentImage.eid
              }
              const response = await PSO.sendPhotoToRemix(sendPhotoArgs);
              if (i === localRemixMedia.length - 1) {
                // Last element sent - first element of the frid
                if (response && response.element_id) {
                  firstElementEid = response.element_id;
                }
              }
            } catch (error) {
              console.error(Strings('error_on_sending_media'));
            }
          } else if (currentImage && currentImage.type === 'file') {
            const targetFile = await ProcessImageForUpload(
              currentImage.file,
              process.env.REACT_APP_PZ_EXIF_JS,
              process.env.REACT_APP_MIN_UPLOAD_PHOTO_WIDTH,
              process.env.REACT_APP_MIN_UPLOAD_PHOTO_HEIGHT,
              process.env.REACT_APP_MAX_UPLOAD_PHOTO_WIDTH,
              process.env.REACT_APP_MAX_UPLOAD_PHOTO_HEIGHT,
              true
            );
            if (targetFile && targetFile !== undefined) {
              // const fileDataURI = currentImage.src;
              // const fileBLOB = FileHelper.dataURItoBlob(fileDataURI);
              try {
                const sendPhotoArgs = {
                  al: authenticated.al,
                  un: authenticated.un,
                  rid: remixCreatedId,
                  Filedata: targetFile,
                  Filename: targetFile.name
                }
                const response = await PSO.sendPhotoToRemix(sendPhotoArgs);
                if (i === localRemixMedia.length - 1) {
                  // Last element sent - first element of the frid
                  if (response && response.element_id) {
                    firstElementEid = response.element_id;
                  }
                }
              } catch (error) {
                console.error(Strings('error_on_sending_media'));
              }
            }
          } else if (currentImage && currentImage.type === 'textphoto') {
            if (currentImage.layers && currentImage.layers.length > 0 && currentImage.layers[0] !== null) {
              const originalFileBLOB = FileHelper.dataURItoBlob(await RemixHelper.generateBasePhotoWithLayer(currentImage.layers));
              const renderedFileBLOB = FileHelper.dataURItoBlob(currentImage.src);
  
              const txts = [];
              if (currentImage.layers && currentImage.layers.length > 0) {
                currentImage.layers.forEach((item) => {
                  if (item.type === 'text') {
                    let x = item.x;
                    let y = item.y;
                    const h = item.h;
                    const w = item.w;

                    if (item.textAlign === 'center') {
                      if (item.renderedW) {
                        x = x - (item.renderedW / 2);
                      }
                      if (item.renderedH) {
                        y = y - (item.renderedH / 2);
                      }
                    }

                    x = x - TextPhotoDefaults.COMPATIBILITY_X_FACTOR;
                    y = y - TextPhotoDefaults.COMPATIBILITY_Y_FACTOR;

                    txts.push({
                      t: RemixHelper.generateTextLayerBreakLine(item),
                      c: encodeURIComponent(item.color),
                      y: y,
                      x: x,
                      h: h,
                      w: w,
                      a: 0,
                      s: item.fontSize / TextPhotoDefaults.SCALE_FACTOR,
                      f: encodeURIComponent(item.font),
                      app: 'web'
                    });
                  }
                });
              }
  
              try {
                const etxtjson = {
                  txts: txts,
                  isTxtPhoto: true
                };

                const sendPhotoArgs = {
                  al: authenticated.al,
                  un: authenticated.un,
                  rid: remixCreatedId,
                  Filedata: originalFileBLOB,
                  Filename: 'remixPhoto.jpg', 
                  etxtjson: JSON.stringify(etxtjson)
                }

                const resp = await PSO.sendPhotoToRemix(sendPhotoArgs);

                if (resp && resp.result === 'success' && resp.element_id) {
                  const elementId = resp.element_id;

                  const replacePhotoArgs = {
                    al: authenticated.al,
                    un: authenticated.un,
                    rid: remixCreatedId,
                    eid: elementId,
                    etxtjson: JSON.stringify(etxtjson),
                    Filedata: renderedFileBLOB,
                    Filename: 'remixPhoto.jpg', 
                  }
                  await PSO.replacePhotoInRemix(replacePhotoArgs);

                  // Changing foto animation to crop to FIT
                  const cropToFixArgs = {
                    al: authenticated.al,
                    un: authenticated.un,
                    etype: 1,
                    eid: elementId,
                    eaid: '1003'
                  }
                  await PSO.modifyElementGlobal(cropToFixArgs);
                }
              } catch (error) {
                console.error(Strings('error_on_sending_media'));
              }
            }
          } else if (currentImage && currentImage.type === 'unsplash') {
            const targetFile = currentImage;
            if (targetFile && targetFile !== undefined) {
              const fileDataURI = currentImage.src;
              const fileBLOB = FileHelper.dataURItoBlob(fileDataURI);
              try {
                const sendPhotoArgs = {
                  al: authenticated.al,
                  un: authenticated.un,
                  rid: remixCreatedId,
                  Filedata: fileBLOB,
                  Filename: targetFile.name
                }
                const response = await PSO.sendPhotoToRemix(sendPhotoArgs);
                if (i === localRemixMedia.length - 1) {
                  // Last element sent - first element of the grid
                  if (response && response.element_id) {
                    firstElementEid = response.element_id;
                  }
                }
              } catch (error) {
                console.error(Strings('error_on_sending_media'));
              }
            }
          } else if (currentImage && currentImage.type === 'video') {
            const targetFile = currentImage;
            if (targetFile && targetFile !== undefined) {
              const fileDataURI = currentImage.src;
              const fileBLOB = FileHelper.dataURItoBlob(fileDataURI);
              try {
                const sendVideoArgs = {
                  al: authenticated.al,
                  un: authenticated.un,
                  rid: remixCreatedId,
                  Filedata: fileBLOB,
                  Filename: targetFile.file.name
                };
                const response = await PSO.sendVideoToRemix(sendVideoArgs);
                if (i === localRemixMedia.length - 1) {
                  // Last element sent - first element of the grid
                  if (response && response.element_id) { firstElementEid = response.element_id; }
                }
              } catch (error) {
                console.error(error);
              }
            }
          }
        }
      }
      toggleLoading(false);

      if (songType === 2 && appleMusicParams !== null) {
        // Defining Apple Music
        toggleLoading(true, Strings('setting_music'));
        try {
          const response = await PSO.modifyRemix({
            un: authenticated.un,
            al: authenticated.al,
            rid: remixCreatedId,
            args: appleMusicParams
          });

          if (response.result !== 'success') {
            const message = (response && response.error) ? response.error : Strings('error_on_request');
            toast.error(message);
          }
        } catch (err) {
          console.error(err);
        }
        toggleLoading(false);
      } else if (songType === 3) {
        // Defining Original Song
        if (song && song.obj && song.obj.element_id) {
          toggleLoading(true, Strings('setting_music'));
          try {
            const args = {
              usoid: song.obj.element_id,
              uso: 1
            }

            const response = await PSO.modifyRemix({
              un: authenticated.un,
              al: authenticated.al,
              rid: remixCreatedId,
              args: args
            });

            if (response.result !== 'success') {
              const message = (response && response.error) ? response.error : Strings('error_on_request');
              toast.error(message);
            }
          } catch (err) {
            console.error(err);
          }
          toggleLoading(false);
        }
      }

      // Setting the remix cover to first photo of grid
      if (firstElementEid) {
        try {
          await PSO.setRemixCover({
            un: authenticated.un,
            al: authenticated.al,
            rid: remixCreatedId,
            eid: firstElementEid
          });
        } catch (err) {
          console.error(err);
        }
      }

      // Calling notifyRemixReady
      try {
        await PSO.notifyRemixReady({
          un: authenticated.un,
          al: authenticated.al,
          rid: remixCreatedId
        });
      } catch (err) {
        console.error(err);
      }

      // Adding remix to collection
      if (currentCampaign && currentCampaign.colid) {
        toggleLoading(true, Strings('ending_video'));
        try {
          const response = await PSO.addRemixToCollection({
            un: authenticated.un,
            al: authenticated.al,
            colid: currentCampaign.colid,
            rid: remixCreatedId
          });
  
          if (response.result === 'success') {
            toast.success(Strings('video_created'));
            history.push(`/campaign/share?rid=${remixCreatedId}`);
          } else {
            const message = (response && response.error) ? response.error : Strings('error_on_request');
            toast.error(message);
          }
        } catch (err) {
          toast.error(Strings('general_error'));
        }
      } else {
        toast.success(Strings('video_created'));
        history.push('/dashboard');

        // Opening the Tiny Page for the created Video
        let publicVideosURL;
        if (remixArguments.mvon === 1) {
          publicVideosURL = process.env.REACT_APP_PUBLIC_VIDEOS_POPFANS;
        } else {
          publicVideosURL = process.env.REACT_APP_PUBLIC_VIDEOS;
        }

        const url = `${publicVideosURL}+${remixCreatedTid}`;
        window.open(url, '_blank');
      }
      toggleLoading(false);
    }
  }, [style, song, songType, remixMedia, toggleLoading, authenticated, remixPars, currentCampaign, history, validateVideoBeforeCreate, hashtagStyle, customLatiLong, checkCredits, creditAction]);

  const previous = useCallback(() => {
    const currentTab = parseInt(activeTab);
    const tab = currentTab - 1;
    toggleTab(`${tab}`);
    scrollTop();
  }, [toggleTab, activeTab, scrollTop]);
  const next = useCallback(() => {
    const currentTab = parseInt(activeTab);
    if (validateDetails(currentTab)) {
      const tab = currentTab + 1;
      toggleTab(`${tab}`);
      scrollTop();
    }
  }, [toggleTab, activeTab, validateDetails, scrollTop]);

  const getPosition = useCallback(() => {
    let latitude;
    let longitude;

    if (currentCampaign && currentCampaign.collati && currentCampaign.collong) {
      // Gets the campaign lati and long
      latitude = currentCampaign.collati;
      longitude = currentCampaign.collong;
      const currentremixPars = remixPars;
        if (latitude) {
          currentremixPars.lati = latitude;
        }
        if (longitude) {
          currentremixPars.long = longitude;
        }
        setRemixPars(currentremixPars);
    } else if (navigator.geolocation) {
      // Gets the navigator lat and long
      navigator.geolocation.getCurrentPosition((position) => {
        latitude = position.coords.latitude;
        longitude = position.coords.longitude;
        const currentremixPars = remixPars;
        if (latitude) {
          currentremixPars.lati = latitude;
        }
        if (longitude) {
          currentremixPars.long = longitude;
        }
        setRemixPars(currentremixPars);
      });
    }
  }, [remixPars, setRemixPars, currentCampaign]);

  const toggleCustomLatiLong = useCallback((lati, long) => {
    if (lati || long) {
      const info = { lati, long };
      setCustomLatiLong(info);
    } else {
      setCustomLatiLong(false)
    }
  }, [setCustomLatiLong]);

  const orderPepblastSongByRa = (songs) => {
    if (songs) {
      songs.sort((a, b) => {
        if (a.ra > b.ra) return -1;
        if (a.ra < b.ra) return 1;
        return 0;
      });
      return songs;
    }
    return false;
  }

  const processItsForMediaGrid = useCallback(async (its, type) => {
    if (its && its.length > 0) {
      const media = [];

      if (type === 'mediapack') {
        its.forEach((item) => {
          if (item.eid) {
            item.src = REACT_APP_PZ_IMAGE_SRC.replace('{id}', item.eid);
            item.type = type;
          }
          media.push(item);
        });
      } else if (type === 'file') {
        for (let i = 0; i < its.length; i++) {
          const file = its[i];
          const FileDataUri = await FileHelper.readFile(file);
          const resizedFileDataUri = await PhotoResizer({
            src: FileDataUri,
            maxWidth: REACT_APP_MAX_UPLOAD_PHOTO_WIDTH,
            maxHeight: REACT_APP_MAX_UPLOAD_PHOTO_HEIGHT
          });

          const item = {
            file: file,
            src: resizedFileDataUri,
            type: type
          };
          media.push(item);
        }
      } else if (type === 'textphoto') {
        its.forEach((item) => {
          const itemToSet = {
            src: item.renderedImage,
            type: type,
            layers: item.layers
          };
          media.push(itemToSet);
        });
      }

      return media;
    } else {
      return false;
    }
  }, []);

  const createAutomatic = useCallback(async () => {
    const createParameter = query.get('create');
    let surpriseMe = false;
    if (currentCampaign && currentCampaign.customPars && currentCampaign.customPars.campaign_surprise_me) {
      surpriseMe = true;
    }

    if (((parseInt(createParameter) === 1 && surpriseMe) || parseInt(createParameter) === 2) && !automaticCreated) {
      // Creating the Video automatically

      if (currentCampaign) {
        let style = 201; // Default STYLE
        if (currentCampaign && currentCampaign.customPars && currentCampaign.customPars.campaign_event_style) {
          style = currentCampaign.customPars.campaign_event_style;
        } else if (currentCampaign && currentCampaign.colevcat) {
          style = parseInt(currentCampaign.colevcat);
        }

        let generatedRandomStyle;

        // Defining hashtag to Create Video
        if (style) {
          const generalCategories = await Assets.getCategories();
          if (generalCategories && generalCategories.its && generalCategories.its.length > 0) {
            const its = generalCategories.its;
            const targetCategory = its.filter((value) => {
              return parseInt(value.id) === style;
            });
            if (targetCategory && targetCategory.length > 0 && targetCategory[0].la) {
              processHashtagStyle(targetCategory[0].la);
            }
          }
        }

        // STYLE
        if (style) {
          toggleLoading(true, Strings('preparing_your_video'));

          const styles = await Assets.getStyle(style);
          const catsImages = await Assets.getCatImages();

          generatedRandomStyle = await RemixHelper.randomizeStyle(styles, catsImages);
          if (generatedRandomStyle) {
            setStyle(generatedRandomStyle);
          }
        }

        // SONG
        if (style) {
          toggleLoading(true, Strings('preparing_your_video'));

          const songs = await Assets.getSongList();
          if (songs && songs.its) {
            songs.its = orderPepblastSongByRa(songs.its);
            if (songs.sbu) {
              songs.sbu = songs.sbu.replace(/https?:\/\//, 'https://');
            }
            if (songs.sfu) {
              songs.sfu = songs.sfu.replace(/https?:\/\//, 'https://');
            }
            if (songs.siu) {
              songs.siu = songs.siu.replace(/https?:\/\//, 'https://');
            }
            if (songs.ssu) {
              songs.ssu = songs.ssu.replace(/https?:\/\//, 'https://');
            }
            if (songs.stu) {
              songs.stu = songs.stu.replace(/https?:\/\//, 'https://');
            }
          }
          const generatedRandomSong = await RemixHelper.randomizeSong(style, songs);
          if (generatedRandomSong) {
            const objToSet = {};
            objToSet.obj = generatedRandomSong;
            objToSet.type = 1;
            objToSet.name = generatedRandomSong.na;
            objToSet.artist = generatedRandomSong.ba;
            objToSet.thumb = `${songs.stu}/${generatedRandomSong.tl}`;
            objToSet.preview = `${songs.ssu}/${generatedRandomSong.sl}`;

            setSong(objToSet);
            setSongType(1);

            if (audioSelectedRef && audioSelectedRef.current) {
              const audio = audioSelectedRef.current;
              if (!audio.paused) {
                audio.pause();
              }
        
              audio.src = objToSet.preview;
            }
          }
        }

        // MEDIA
        let mediaToSet = [];
        let textphotos = [];

        // MEDIAPACK
        if (style) {
          toggleLoading(true, Strings('preparing_your_video'));

          const _t = new Date().getTime();
          const mediaPackMapJson = await axios.get(`${mediaPackMapJsonSrc}?_t=${_t}`);
          const styleForMediaPack = RemixHelper.randomizeMediaPack(style, GenresMap, mediaPackMapJson.data);
          if (styleForMediaPack) {
            const mediaPackArgs = {
              un: authenticated.un,
              al: authenticated.al,
              catid: styleForMediaPack,
              effect: 'e1'
            }
            const response = await PSO.getMediaPack(mediaPackArgs);
            if (response.result === 'success' && response.its) {

              const newMedia = await processItsForMediaGrid(response.its, 'mediapack');
              mediaToSet = mediaToSet.concat(newMedia);
            }
          }
        }

        // TEXTPHOTO
        if (ENABLE_GENERATE_TEXT_PHOTO) {
          toggleLoading(true, Strings('preparing_your_video'));

          const styles = await Assets.getStyle(style);
          const catsImages = await Assets.getCatImages();
          let randomStyleForTextPhoto = await RemixHelper.randomizeStyle(styles, catsImages);

          if (randomStyleForTextPhoto) {
            let textPhotoBackground = randomStyleForTextPhoto.posterSrc;
            let txtPhotoBgBase64Img = null;
            try {
              txtPhotoBgBase64Img = await CanvasHelper.getBase64ImageFromURL(textPhotoBackground);
            } catch (err) {
              txtPhotoBgBase64Img = null;
            }
  
            // TextPhoto for Campaign Description
            if (currentCampaign.cold) {
              const txtDesc = [
                currentCampaign.cold
              ];
              const txtPhotoDescription = await RemixHelper.generateTextPhoto(
                txtDesc,
                txtPhotoBgBase64Img,
                TextPhotoDefaults.CANVAS_DEFAULT_WIDTH,
                TextPhotoDefaults.CANVAS_DEFAULT_HEIGHT
              );
              if (txtPhotoDescription && txtPhotoDescription.layers && txtPhotoDescription.renderedImage) {
                const textPhotos = [{
                  layers: txtPhotoDescription.layers,
                  renderedImage: txtPhotoDescription.renderedImage
                }];
                const itemToSet = await processItsForMediaGrid(textPhotos, 'textphoto');
                if (itemToSet) {
                  textphotos = [...itemToSet, ...textphotos];
                }
              }
            }
            
            // TextPhoto for Campaign Participants
            if (currentCampaign.colpar) {
              randomStyleForTextPhoto = await RemixHelper.randomizeStyle(styles, catsImages, randomStyleForTextPhoto);
              textPhotoBackground = randomStyleForTextPhoto.posterSrc;
              txtPhotoBgBase64Img = null;
              try {
                txtPhotoBgBase64Img = await CanvasHelper.getBase64ImageFromURL(textPhotoBackground);
              } catch (err) {
                txtPhotoBgBase64Img = null;
              }

              const txtPhotoParticipants = await RemixHelper.generateTextPhoto(
                ['with', currentCampaign.colpar],
                txtPhotoBgBase64Img,
                TextPhotoDefaults.CANVAS_DEFAULT_WIDTH,
                TextPhotoDefaults.CANVAS_DEFAULT_HEIGHT
              );
              if (txtPhotoParticipants && txtPhotoParticipants.layers && txtPhotoParticipants.renderedImage) {
                const textPhotos = [{
                  layers: txtPhotoParticipants.layers,
                  renderedImage: txtPhotoParticipants.renderedImage
                }];
                const itemToSet = await processItsForMediaGrid(textPhotos, 'textphoto');
                if (itemToSet) {
                  textphotos = [...textphotos, ...itemToSet];
                }
              }
            }
  
            // TextPhoto for Campaign Local, date and pricing
            randomStyleForTextPhoto = await RemixHelper.randomizeStyle(styles, catsImages, randomStyleForTextPhoto);
            textPhotoBackground = randomStyleForTextPhoto.posterSrc;
            txtPhotoBgBase64Img = null;
            try {
              txtPhotoBgBase64Img = await CanvasHelper.getBase64ImageFromURL(textPhotoBackground);
            } catch (err) {
              txtPhotoBgBase64Img = null;
            }

            let txtLocDatePricing = [];
            if (currentCampaign.colloc) {
              txtLocDatePricing.push(`Place: ${currentCampaign.colloc}`);
            }
            if (currentCampaign.colad) {
              txtLocDatePricing.push(`Address: ${currentCampaign.colad}`);
            }
            if ((currentCampaign.colds && currentCampaign.colds !== '00') || (currentCampaign.colde && currentCampaign.colde !== '00')) {
              let date = 'Date: ';
              if (currentCampaign.colds && currentCampaign.colds !== '00') {
                date += currentCampaign.colds.substring(0, 10);
              }
              if (currentCampaign.colde && currentCampaign.colde !== '00') {
                date += ` - ${currentCampaign.colde.substring(0, 10)}`;
              }
              txtLocDatePricing.push(date);
            }
            if (currentCampaign.colpri) {
              txtLocDatePricing.push(`Price: ${currentCampaign.colpri}`);
            }
            if (txtLocDatePricing.length > 0) {
              const txtPhotoLocDatePricing = await RemixHelper.generateTextPhoto(
                txtLocDatePricing,
                txtPhotoBgBase64Img,
                TextPhotoDefaults.CANVAS_DEFAULT_WIDTH,
                TextPhotoDefaults.CANVAS_DEFAULT_HEIGHT
              );
              if (txtPhotoLocDatePricing && txtPhotoLocDatePricing.layers && txtPhotoLocDatePricing.renderedImage) {
                const textPhotos = [{
                  layers: txtPhotoLocDatePricing.layers,
                  renderedImage: txtPhotoLocDatePricing.renderedImage
                }];
                const itemToSet = await processItsForMediaGrid(textPhotos, 'textphoto');
                if (itemToSet) {
                  textphotos = [...textphotos, ...itemToSet];
                }
              }
              
            }
  
            // TextPhoto for Organized By and URLs
            randomStyleForTextPhoto = await RemixHelper.randomizeStyle(styles, catsImages, randomStyleForTextPhoto);
            textPhotoBackground = randomStyleForTextPhoto.posterSrc;
            txtPhotoBgBase64Img = null;
            try {
              txtPhotoBgBase64Img = await CanvasHelper.getBase64ImageFromURL(textPhotoBackground);
            } catch (err) {
              txtPhotoBgBase64Img = null;
            }
            
            let txtOrgUrls = [];
            if (currentCampaign.colorg) {
              txtOrgUrls.push(`By: ${currentCampaign.colorg}`);
            }
            if (currentCampaign.colurl) {
              txtOrgUrls.push('Info:');
              txtOrgUrls.push(`${currentCampaign.colurl}`);
            }
            if (currentCampaign.colcurl) {
              txtOrgUrls.push('Website:');
              txtOrgUrls.push(`${currentCampaign.colcurl}`);
            }
            if (txtOrgUrls.length > 0) {
              const txtPhotoOrgUrls = await RemixHelper.generateTextPhoto(
                txtOrgUrls,
                txtPhotoBgBase64Img,
                TextPhotoDefaults.CANVAS_DEFAULT_WIDTH,
                TextPhotoDefaults.CANVAS_DEFAULT_HEIGHT
              );
              if (txtPhotoOrgUrls && txtPhotoOrgUrls.layers && txtPhotoOrgUrls.renderedImage) {
                const textPhotos = [{
                  layers: txtPhotoOrgUrls.layers,
                  renderedImage: txtPhotoOrgUrls.renderedImage
                }];
                const itemToSet = await processItsForMediaGrid(textPhotos, 'textphoto');
                if (itemToSet) {
                  textphotos = [...textphotos, ...itemToSet];
                }
              }
            }
          }
        }

        if (textphotos.length > 0) {
          // Algorithm testing purposes
          // const testPhotos = ['photo1', 'photo2', 'photo3','photo4', 'photo5', 'photo6', 'photo7', 'photo8', 'photo9', 'photo10', 'photo11', 'photo12', 'photo13', 'photo14', 'photo15'];
          // const textTexts = ['text1', 'text2', 'text3', 'text4'];
          const intercalated = RemixHelper.intercalateArrays(mediaToSet, textphotos);
          mediaToSet = intercalated;
        }

        if (mediaToSet.length > 0) {
          // Filtering media set to avoid problems
          const filteredMediaSet = mediaToSet.filter((value) => {
            if (value) {
              return true;
            } else {
              return false;
            }
          });
          setRemixMedia(filteredMediaSet);
        }

        // DETAILS
        toggleLoading(true, Strings('preparing_your_video'));

        const currentRemixPars = remixPars;
        if (currentCampaign.coln) {
          currentRemixPars.rti = currentCampaign.coln;

          // Generating startag
          currentRemixPars.rstag = RemixHelper.generateStarTag(currentCampaign.coln);

          let startagExists = false;
          const response = await PSO.checkStarTagExists({
            un: authenticated.un,
            al: authenticated.al,
            rstag: currentRemixPars.rstag,
            getusersuggested: 1
          });
          if (response && response.result) {
            if (response.result === 'success') {
              if (response.systemstartagexists && (response.systemstartagexists === 1 || response.systemstartagexists === '1')) {
                startagExists = true;
              }
              if (response.userstartagexists && (response.userstartagexists === 1 || response.userstartagexists === '1')) {
                startagExists = true;
              }
              if (startagExists) {
                // Getting the suggested startag
                if (response.usersuggestedstartag) {
                  currentRemixPars.rstag = response.usersuggestedstartag;
                  startagExists = false;
                }
              }
            }
          }
          if (startagExists) {
            // Trying to generate a new startag with a random number at the end - local method
            const maxRandom = 99;
            const random = randomIntFromInterval(0, maxRandom);
            if (currentRemixPars.rstag.length >= 23) {
              currentRemixPars.rstag = currentRemixPars.rstag.substring(0, currentRemixPars.rstag.length - 3);
            }
            currentRemixPars.rstag = `${currentRemixPars.rstag}${random}`;
          }
        }

        let description = '';
        if (currentCampaign.cold) {
          description += `${currentCampaign.cold}\n\n`;
        }
        if (currentCampaign.colloc) {
          description += `Place: ${currentCampaign.colloc}\n`;
        }
        if (currentCampaign.colad) {
          description += `Address: ${currentCampaign.colad}\n`;
        }
        if (currentCampaign.colpri) {
          description += `Price: ${currentCampaign.colpri}\n`;
        }
        if (currentCampaign.colpar) {
          description += `with: ${currentCampaign.colpar}\n`;
        }
        if (currentCampaign.colurl) {
          description += `Info: ${currentCampaign.colurl}\n`;
        }
        if ((currentCampaign.colds && currentCampaign.colds !== '00') || (currentCampaign.colde && currentCampaign.colde !== '00')) {
          let date = 'Date: ';
          if (currentCampaign.colds && currentCampaign.colds !== '00') {
            date += currentCampaign.colds.substring(0, 10);
          }
          if (currentCampaign.colde && currentCampaign.colde !== '00') {
            date += ` --- ${currentCampaign.colde.substring(0, 10)}`;
          }
          date += '\n';
          description += date;
        }
        if (currentCampaign.colcurl) {
          description += `Website: ${currentCampaign.colcurl}\n`;
        }
        if (currentCampaign.colorg) {
          description += `By: ${currentCampaign.colorg}\n`;
        }
        if (description.length > 2) {
          // Removing the last \n of the description
          description = description.substring(0, description.length - 1);
        }
        currentRemixPars.rde = description;
        setRemixPars(currentRemixPars);
      }

      // Toggle tab 5
      toggleTab('5');
      setShowCreatedVideoAlert(true);

      toggleLoading(false);

      setAutomaticCreated(true);
    }
  }, [query, currentCampaign, toggleLoading, remixPars, setRemixPars, setStyle, setSong, authenticated, processItsForMediaGrid, setRemixMedia, setSongType, toggleTab, setShowCreatedVideoAlert, automaticCreated, setAutomaticCreated, processHashtagStyle]);

  useEffect(() => {
    getPosition();
    createAutomatic();
  }, [getPosition, createAutomatic]);

  const goBackNavigation = useCallback(() => {
    if (currentCampaign) {
      history.push('/campaign');
    } else {
      history.push('/dashboard');
    }
  }, [currentCampaign, history]);

  return (
    <Fragment>
      <Card className='mb-3'>

        <CardHeader>
          <Nav justified>
            <NavItem>
              <NavLink
                href='#'
                className={classnames({ active: activeTab === '1' })}
                onClick={() => toggleTab('1')}
              >
                {Strings('1_style')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href='#'
                className={classnames({ active: activeTab === '2' })}
                onClick={() => toggleTab('2')}
              >
                {Strings('2_music')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href='#'
                className={classnames({ active: activeTab === '3' })}
                onClick={() => toggleTab('3')}
              >
                {Strings('3_photos')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href='#'
                className={classnames({ active: activeTab === '4' })}
                onClick={() => toggleTab('4')}
              >
                {Strings('4_details')}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href='#'
                className={classnames({ active: activeTab === '5' })}
                onClick={() => toggleTab('5')}
              >
                {Strings('5_review')}
              </NavLink>
            </NavItem>
          </Nav>
        </CardHeader>

        <CardBody>

          <TabContent activeTab={activeTab}>

            <TabPane tabId='1'>
              <VideoStyle
                parentStyle={style}
                setParentStyle={setStyle}
                processHashtagStyle={processHashtagStyle}
              />
            </TabPane>

            <TabPane tabId='2'>
              <VideoSong
                parentSong={song}
                parentSetSong={setSong}
                parentSongType={songType}
                parentSetSongType={setSongType}
                audioPreviewRef={audioPreviewRef}
                audioSelectedRef={audioSelectedRef}
                createMode={true}
              />
            </TabPane>

            <TabPane tabId='3'>
              <VideoPhotos
                remixMedia={remixMedia}
                setRemixMedia={setRemixMedia}
              />
            </TabPane>

            <TabPane tabId='4'>
              <VideoDetails
                remixPars={remixPars}
                setRemixPars={setRemixPars}
                toggleLatiLong={toggleCustomLatiLong}
              />
            </TabPane>

            <TabPane tabId='5'>
              {showCreatedVideoAlert && (
                <UncontrolledAlert>
                  {Strings('created_video_message')}
                </UncontrolledAlert>
              )}
              
              <VideoReview
                remixPars={remixPars}
                selectedStyle={style}
                selectedSong={song}
                parentSongType={songType}
                changeStyleCallback={() => toggleTab('1')}
                changeSongCallback={() => toggleTab('2')}
                changeDetailsCallback={() => toggleTab('4')}
              />
            </TabPane>

            <div className="divider" />

            <div className="clearfix">
              <div>
                <Button
                  color="secondary"
                  className="btn-shadow float-left btn-wide btn-pill"
                  outline
                  style={showCancelBtn ? {} : { display: 'none' }}
                  onClick={toggleModalCancel}
                >
                  {Strings('cancel')}
                </Button>
              
                <Button
                  color="secondary"
                  className="btn-shadow float-left btn-wide btn-pill"
                  outline
                  style={showPreviousBtn ? {} : { display: 'none' }}
                  onClick={previous}
                >
                  {Strings('previous')}
                </Button>

                <Button
                  color="primary"
                  className="btn-shadow btn-wide float-right btn-pill btn-hover-shine"
                  style={showNextBtn ? {} : { display: 'none' }}
                  onClick={next}
                >
                  {Strings('next')}
                </Button>
                <Button
                  color="success"
                  className="btn-shadow btn-wide float-right btn-pill btn-hover-shine"
                  style={showCreateBtn ? {} : { display: 'none' }}
                  onClick={createVideo}
                >
                  {Strings('CREATE')} {labelCreditsCost}
                </Button>
              </div>
            </div>

          </TabContent>

        </CardBody>
      </Card>

      <Modal
        isOpen={modalCancel}
        toggle={toggleModalCancel}
      >
        <ModalHeader toggle={toggleModalCancel}>
          {Strings('confirm_cancel')}
        </ModalHeader>
        <ModalBody>
          <p>
            {Strings('are_you_sure_cancel')}
          </p>
          <div className="text-right">
            <Button
              className="btn-wide mb-2 mr-2"
              size="md"
              color="secondary"
              onClick={toggleModalCancel}
            >
              {Strings('no')}
            </Button>
            <Button
              className="btn-wide mb-2 mr-2"
              size="md"
              color="danger"
              onClick={goBackNavigation}
            >
              {Strings('yes_cancel')}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}
